const key_member = 'member_info'


var _getMember = function() {
	var data = localStorage.getItem(key_member);
	if (data) {
		try {
			return JSON.parse(data);
		} catch (err) {
			return {};
		}
	}
	return {};
}

var _saveMember = function(member) {
	if (member) {
		//先查找本地存储的用户信息，如果要存储的用户信息没有key，就用本地的替换
		var mOld = _getMember();
		if (mOld && !member.key) {
			member.key = mOld.key;
		}
		localStorage.setItem(key_member, JSON.stringify(member));
	} else {
		localStorage.removeItem(key_member);
	}
}


var MemberInfo = {
	getMemberInfo: function() {
		return _getMember();
	},
	saveMemberInfo: function(member) {
		_saveMember(member);
	},
	isLogin: function() {
		var member = _getMember();
		if (member && member.key) {
			return true;
		}
		return false;
	}
}

export default MemberInfo


// WEBPACK FOOTER //
// ./src/global/js/memberinfo.js